// Source: app/scripts/controllers/company-users.js
/**
 * Created by ristes on 20.4.15.
 */


Auction.controller('CompanyUsersController', [
  '$scope',
  '$modal',
  '$filter',
  '$location',
  'toaster',
  'crudService',
  '$window',
  function ($scope, $modal, $filter, $location, toaster, crudService, $window) {

    // var addNewCompanyUserScope = $scope.$new(true);

    var registeredUsersService = crudService('registered_users', {
      'createCompanyUser': {
        method: 'POST',
        url: '/data/rest/registered_users/create_company_user'
      },
      'deactivateCompanyUser': {
        method: 'POST',
        url: '/data/rest/registered_users/deactivate_company_user'
      },
      enable: {
        method: 'POST',
        url: "/data/rest/registered_users/enable_company_user"
      },
      disable: {
        method: 'POST',
        url: "/data/rest/registered_users/disable_company_user"
      },
      block: {
        method: 'POST',
        url: "/data/rest/registered_users/block"
      }
    });

    $scope.addCompanyUser = function () {
      $scope.entity = {};
      $scope.entity.company = $scope.$root.user.company;
      console.log('in add cmp user');
      $scope.modalAddCompanyUser.show();
    };

    $scope.disableEntity = {};

    $scope.blockEntity = {};
    $scope.modalDisable = $modal({
      scope: $scope,
      template: 'forms/modals/disable.html',
      show: false
    });


    $scope.cancelEntity = {};

    $scope.modalAddCompanyUser = $modal({
      scope: $scope,
      template: 'forms/admin/auth/add_company_user.html',
      show: false
    });

    $scope.modalBlock = $modal({
      scope: $scope,
      template: 'forms/modals/block_company.html',
      show: false
    });



    $scope.disable = function () {
      registeredUsersService.disable({
        username: $scope.disableEntity.username,
        days: $scope.disableEntity.days
      }, function () {
        $scope.modalDisable.hide();
        $window.location.reload();

        // $scope.companyUsersCrud.reload();
        $scope.disableEntity = {};
      });
    };

    $scope.block = function () {
      registeredUsersService.block({
        registeredUser: $scope.blockEntity.registeredUser,
        blockReason: $scope.blockEntity.blockReason
      }, function () {
        $scope.modalBlock.hide();
        $scope.traderCrud.reload();
        delete $scope.blockEntity.blockReason;
        $scope.blockEntity = {};
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("BLOCKED"));
      });
    };

    $scope.saveNewCompanyUser = function () {
      console.log('password');
      console.log($scope.entity.password);
      console.log('ConfirmPassword');

      console.log($scope.confirmPassword);


      if ($scope.entity.password !== $scope.entity.confirmPassword) {
        toaster.pop('error', $filter('translate')('error'), $filter(
          'translate')('eauction.confirm_password_missmatch'));
        error = true;
        return;
      }

      var payload = {
        username: $scope.entity.username,
        password: $scope.entity.password,
        email: $scope.entity.email,
        phone: $scope.entity.phone,
        lang: $scope.entity.lang,
        company: $scope.entity.company
      };

      registeredUsersService.createCompanyUser(payload, function (data) {
        $scope.modalAddCompanyUser.hide();
        $window.location.reload();
      })
    };

    $scope.afterInit = function (crudScope) {
      crudScope.deactivateCompanyUser = function (user) {
        crudScope.entity = user;
        crudScope.modalDeactivateCompanyUser.show();
      };

      crudScope.saveDeactivateCompanyUser = function (user) {
        registeredUsersService.deactivateCompanyUser(crudScope.entity, function (data) {
          crudScope.modalDeactivateCompanyUser.hide();
        })
      };


      crudScope.modalDeactivateCompanyUser = $modal({
        scope: crudScope,
        template: 'forms/admin/auth/deactivate_company_user.html',
        show: false
      });


      crudScope.disableUser = function (entity) {
        $scope.disableEntity = entity;
        $scope.modalDisable.$promise.then($scope.modalDisable.show);
      };


      crudScope.enableUser = function (entity) {
        registeredUsersService.enable({
          username: entity.username
        }, function () {
          $window.location.reload();
          // $scope.companyUsersCrud.reload();
          // $scope.companyUsersCrud.edit(entity.id);
        });
      };
      crudScope.blockUser = function (entity) {
        $scope.blockEntity.registeredUser = entity;
        $scope.modalBlock.$promise.then($scope.modalBlock.show);
      };

    }


  }
]);
